import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Briefcase } from "lucide-react";

const CareersPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem("careersPopupSeen");
    if (!seen) {
      const timer = setTimeout(() => setIsOpen(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem("careersPopupSeen", "true");
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-[420px] mx-auto">
        <DialogHeader>
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <Briefcase className="h-6 w-6 text-primary" />
          </div>
          <DialogTitle className="text-xl sm:text-2xl font-bold text-center">
            Faça parte da nossa equipe
          </DialogTitle>
          <DialogDescription className="text-center pt-2 text-sm sm:text-base">
            Estamos sempre em busca de novos talentos. Envie seu currículo e venha crescer com a EW Saúde Ambiental.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 pt-3">
          <Button asChild size="lg" className="w-full" onClick={handleClose}>
            <Link to="/trabalhe-conosco">
              <Briefcase className="w-5 h-5 mr-2" />
              Quero me candidatar
            </Link>
          </Button>
          <Button variant="outline" size="lg" className="w-full" onClick={handleClose}>
            Agora não
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CareersPopup;
